<template>
  <input
    ref="input"
    type="text"
    class="form-control"
    :value="value"
    @change="fieldUpdated"
  />
</template>

<script>
  import Issue from './emission-field'

  export default {
    name: 'DecimalField',
    props: {
      id: {
        type: String,
        required: true
      },
      value: {
        default: '',
        required: false
      }
    },
    methods: {
      fieldUpdated: function () {
        this.$emit(
          'input',
          Issue.createField(this.id, this.$refs.input.value, true)
        )
      }
    }
  }
</script>
